export default "__VITE_ASSET__Afxj9iXK__"